import { Injectable } from '@angular/core';
import { shareReplay, catchError, of, tap } from 'rxjs';
import { AppStorageService, USER_INFO_TOKEN, TOTAL_ENTITIES } from '@shared/services/app-storage.service';
import { UserSharedService } from '@shared/services/user-shared.service';
import { IUser } from '@shared/models/iuser.model';

/**
 * Service responsible for resolving entity display options.
 */
@Injectable({ providedIn: 'root' })
export class EntityDisplayOptionsService {
  constructor(
    private userSharedService: UserSharedService,
    private appStorage: AppStorageService
  ) {}

  /**
   * Resolves the entity display options.
   * Retrieves the user's country and line of business keys from the app storage,
   * and then fetches the user's entities using the UserSharedService.
   * The results are stored in the app storage for future use.
   * @returns An observable that emits the user's entities.
   */
  resolve() {
    const { userCountrySkey, userLobSkey } = this.appStorage.getItem<IUser>(USER_INFO_TOKEN);
    return this.userSharedService.getUserEntities(userCountrySkey, userLobSkey).pipe(
      shareReplay(),
      catchError(() => of([])),
      tap(results => this.appStorage.setItem(TOTAL_ENTITIES, results))
    );
  }
}
